import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/liquidGlass.css";
import App from "@/App";

// === iOS CAPACITOR DETECTION ===
const isCapacitorNative = 
  (window.Capacitor?.isNativePlatform?.()) ||
  window.location?.origin?.startsWith('capacitor://') ||
  window.location?.protocol === 'capacitor:';

// === iOS CAPACITOR BACKEND URL FIX ===
if (isCapacitorNative) {
  window.__HEAREN_BACKEND_URL__ = 'https://hearen-backend.onrender.com';
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
